import { PushNotifications } from "@capacitor/push-notifications";
import * as Sentry from "@sentry/vue";

import { APP_ROUTES } from "@/Generated/Routes/paths";

import useAppStore from "@/Modules/App/Store";
import useAuthStore from "../Store";
import usePushStore from "@/Modules/PushNotifications/Store";

import { logout } from "@/Services/TherapyApi/Auth";

import { isApp } from "@/Utils/Ionic";
import { danger } from "@/Utils/Debug";
import { isValidString } from "@/Utils/String";

import AppRouter from "@/Router";

async function logoutAH() {
  const appStore = useAppStore();
  const authStore = useAuthStore();
  const pushStore = usePushStore();
  const currentToken = `${authStore.userToken}`;

  if (isApp()) {
    if (isValidString(pushStore.token)) {
      await pushStore.updatePushToken(false);
    }

    PushNotifications.unregister().catch((e) => Sentry.captureException(e));
  }

  await appStore.clearStores();

  AppRouter.push({ name: APP_ROUTES.login.root.name });

  logout(currentToken).catch((e: Error) => {
    danger("Error logout", e);
  });
}

export default logoutAH;
